<template lang="pug">
q-input.tech-map-input(
  filled,
  :value="value",
  :placeholder="value || '-'",
  :label-slot="false",
  :type="type",
  @input="onChange($event)"
)
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  /**
   * Значение поля. Пример: `"123" | 123`
   */
  value: { type: [String, Number], default: () => "" },
  /* Тип поля. Принимает строку. Пример: "Number" */
  type: { type: String, default: "String" },
});

const emit = defineEmits(["change"]);

const value = computed(() => props.value);

const onChange = val => {
  emit("change", val);
};
</script>

<style lang="scss">
.tech-map-input {
  .q-field__control {
    padding: 0;
    background: transparent;
    height: fit-content;

    .q-field__control-container {
      input {
        padding: 0;

        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #5b7aff;
      }
    }
  }
}
</style>
